// extracted by mini-css-extract-plugin
module.exports = {"CookieConsent":"CookieConsent_CookieConsent__T0wFN","ConsentBar":"CookieConsent_ConsentBar__tKorn"};